<template>
  <div id="payment-creator">
    <div class="sidebar">
      <PaymentSidebar></PaymentSidebar>
    </div>
    <div class="content">
        <GlobalDiscountLabel></GlobalDiscountLabel>
        <div
          class="content-wrapper"
          :class="{
            'content-wrapper--lowered': globalDiscountText && isGlobalDiscountLabelShowed
          }"
        >
          <!-- <div class="flex-right mb-20">
            <HelpCall></HelpCall>
          </div> -->
          <PaymentStepTitle></PaymentStepTitle>
          <router-view></router-view>
        </div>
    </div>
    <transition name="fade">
      <div class="loader-wrapper" v-if="loadingCreatorData || loadingUserData || sendingOrder">
        <div class="loader"><div></div><div></div><div></div><div></div></div>
      </div>
    </transition>
    <PopupPatient></PopupPatient>
  </div>
</template>

<script>
import GlobalDiscountLabel from '../../components/PaymentCreator/GlobalDiscountLabel'
import HelpCall from '../../components/PaymentCreator/HelpCall'
import PaymentSidebar from '../../components/PaymentCreator/PaymentSidebar'
import PaymentStepTitle from '../../components/PaymentCreator/PaymentStepTitle'
import PopupPatient from '../../components/PaymentCreator/PopupPatient'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'PaymentCreator',
  components: {
    HelpCall,
    PaymentSidebar,
    PaymentStepTitle,
    GlobalDiscountLabel,
    PopupPatient
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ]),
    ...mapState([
      'globalDiscountText',
      'isGlobalDiscountLabelShowed',
      'loadingCreatorData',
      'loadingUserData',
      'sendingOrder'
    ])
  }
}

</script>

<style scoped>
#payment-creator {
  display: flex;
  min-height: 100%;
}
.sidebar {
  flex-basis: 250px;
  flex-shrink: 0;
}
.content {
  background-color: #F5F5F5;
  flex-grow: 1;
  max-width: calc(100% - 250px);
}
.content-wrapper{
  background-color: #F2F2F2;
  box-shadow: -5px 0 10px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 20px 40px;
  min-height: calc(100% - 40px);
}
.loader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 9999;
}
.loader {
  display: inline-block;
  position: absolute;
  width: 64px;
  height: 64px;
  top: 50%;
  left: 50%;
  margin-left: -32px;
  margin-right: -32px;
}
.loader div {
  position: absolute;
  top: 27px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #41cda8;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.loader div:nth-child(1) {
  left: 6px;
  animation: loader1 0.6s infinite;
}
.loader div:nth-child(2) {
  left: 6px;
  animation: loader2 0.6s infinite;
}
.loader div:nth-child(3) {
  left: 26px;
  animation: loader2 0.6s infinite;
}
.loader div:nth-child(4) {
  left: 45px;
  animation: loader3 0.6s infinite;
}
@keyframes loader1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes loader3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes loader2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(19px, 0);
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
@media screen and (max-width: 768px){
  .step-title-container{
    display: none;
  }
  .sidebar{
    flex-basis: auto;
  }
  .content {
    flex-grow: 1;
    max-width: 100%;
  }
  .content-wrapper{
    padding-top: 110px;
  }
  .content-wrapper--lowered{
    padding-top: 110px;
  }
}
@media screen and (max-width: 480px){
  .content-wrapper{
    padding-top: 110px;
  }
  .content-wrapper--lowered{
    padding-top: 110px;
  }
  .row .more-info{
    max-width: calc(100%);
    flex: 1 0 calc(100%);
    margin-bottom: 30px;
  }
  .row .button-wrapper {
    max-width: calc(100%);
    flex: 1 0 calc(100%);
    text-align: center;
  }
  .plan-details .button-wrapper .button {
    margin-left: auto;
    margin-right: auto;
    width: calc(320px - 120px);
    text-align: center;
  }
}
</style>
